{
  "name": "@preprio/prepr-nextjs",
  "version": "2.2.2",
  "description": "Next.js package for Prepr CMS preview functionality with advanced debugging and visual editing capabilities",
  "main": "dist/react/index.cjs",
  "types": "./dist/react/index.d.ts",
  "module": "./dist/react/index.js",
  "type": "module",
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "clean": "rm -rf dist",
    "check": "tsc --noEmit && eslint src --ext .ts,.tsx && prettier --check \"src/**/*.{ts,tsx,js,jsx,json,md}\"",
    "fix": "eslint src --ext .ts,.tsx --fix && prettier --write \"src/**/*.{ts,tsx,js,jsx,json,md}\"",
    "changeset": "changeset",
    "version": "changeset version",
    "release": "pnpm run build && changeset publish",
    "prepublishOnly": "pnpm run check && pnpm run build"
  },
  "exports": {
    "./middleware": {
      "import": "./dist/middleware/index.js",
      "types": "./dist/middleware/index.d.ts",
      "require": "./dist/middleware/index.cjs"
    },
    "./server": {
      "import": "./dist/server/index.js",
      "types": "./dist/server/index.d.ts",
      "require": "./dist/server/index.cjs"
    },
    "./react": {
      "import": "./dist/react/index.js",
      "types": "./dist/react/index.d.ts",
      "require": "./dist/react/index.cjs"
    },
    "./utils": {
      "import": "./dist/utils/index.js",
      "types": "./dist/utils/index.d.ts",
      "require": "./dist/utils/index.cjs"
    },
    "./types": {
      "import": "./dist/types/index.js",
      "types": "./dist/types/index.d.ts",
      "require": "./dist/types/index.cjs"
    },
    "./index.css": {
      "import": "./dist/index.css",
      "require": "./dist/index.css"
    }
  },
  "files": [
    "dist",
    "package.json"
  ],
  "keywords": [
    "prepr",
    "cms",
    "nextjs",
    "preview",
    "visual-editing",
    "headless-cms",
    "react",
    "typescript",
    "debug",
    "stega"
  ],
  "author": "Preprio",
  "license": "MIT",
  "packageManager": "pnpm@10.5.2",
  "devDependencies": {
    "@changesets/cli": "^2.30.0",
    "@eslint/js": "^9.39.2",
    "@types/node": "^25.4.0",
    "@types/react": "19.2.14",
    "@types/react-dom": "19.2.3",
    "@typescript-eslint/eslint-plugin": "^8.57.0",
    "@typescript-eslint/parser": "^8.57.0",
    "autoprefixer": "^10.4.27",
    "cssnano": "^7.1.3",
    "eslint": "^9.39.2",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.5",
    "eslint-plugin-react": "^7.37.5",
    "eslint-plugin-react-hooks": "^7.0.1",
    "next": "16.1.6",
    "postcss": "^8.5.8",
    "prettier": "^3.8.1",
    "prettier-plugin-tailwindcss": "^0.7.2",
    "react": "^19.2.4",
    "react-dom": "^19.2.4",
    "tailwindcss": "^3.4.17",
    "tsup": "^8.5.1",
    "typescript": "^5.9.3"
  },
  "peerDependencies": {
    "next": "^16.0.3 || ^15.0.5 || ^15.1.9 || ^15.2.6 || ^15.3.6 || ^15.4.8 || ^15.5.7 || ^14.0.0 || ^13.0.0",
    "react": "^19.0.0 || ^18.0.0 || ^17.0.0 ",
    "react-dom": "^19.0.0 || ^18.0.0 || ^17.0.0"
  },
  "dependencies": {
    "@headlessui/react": "^2.2.9",
    "@vercel/functions": "^3.4.3",
    "@vercel/stega": "^1.0.0",
    "clsx": "^2.1.1",
    "postcss-cli": "^11.0.1",
    "tailwind-merge": "^3.5.0",
    "zustand": "^5.0.11"
  }
}
